<template>
<div v-if="all_tasks.length" class="card">
    <div class="card-header">Tasks</div>
    <ul class="list-group list-group-flush list-group-borderless">
        <task v-for="task in all_tasks"
            :key="task.id"
            :task="task"
            :task_types="task_types"
            :show_edit="true"
            @status-changed="changeStatus($event)"
            @task-updated="updateTask($event)"
            @task-deleted="deleteTask($event)">  
        </task>    
    </ul> 
</div>
</template>

<script>

    import { mapState } from 'vuex';
    import Task from './Task';

    export default {   
        components: {
            Task
        },

        props: ['tasks', 'morphable_id', 'morphable_type', 'display_name'],

        data() {
            return {
                options: false,
                //current: moment(),
                all_tasks: this.tasks,
                task_types: [
                    { 'label': 'Task', 'value': 'task' },
                    { 'label': 'Follow up', 'value': 'follow_up' },
                ],
                new_task: {},
            }
        },

        created() {
            this.new_task = {
                title: '',
                due_date: '',
                type: 'task',
                status: 0,
                user_id: this.user.id,
                client_id: this.user.client_id,
                taskable: {
                    morphable_id: this.morphable_id,
                    morphable_type: this.morphable_type,
                }
            };
        },

        mounted() {
            /* Axios Success Interceptor */
            axios.interceptors.request.use(
            function axiosRequestInterceptor(request) {
                if(request.data) {
                    Object.keys(request.data).forEach(e => {
                        if(request.data[e] instanceof Date) {
                            request.data[e] = moment(request.data[e]).format('YYYY-MM-DD');
                        }
                    });
                }
                return request;
            });

            this.$root.$on('set_follow_up', data => {
                this.new_task.type = 'follow_up';
                this.new_task.title = 'Follow up with ' + this.display_name;
                this.addTask();
            });
        },

        methods: {
        	addTask() {
        		axios.post('/api/tasks/store', this.new_task).then(({data}) => {
                    this.all_tasks.push(data);
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: 'Task saved',
                    });
                });
        	},

            toggleOptions() {
                this.options = !this.options;
                this.task_type = { 'label': 'Task', 'value': 'task' };
            },

            changeStatus($event) {
                axios.put('/api/tasks/' + $event.id + '/status', $event).then(({ data }) => { 
                    //update the task in the list
                    let index = this.all_tasks.map(task => { return task.id; }).indexOf($event.id);
                    this.all_tasks[index].status = $event.status;
                });            
            },

            updateTask($event) {                
                axios.put('/api/tasks/' + $event.id, $event).then(({data}) => {
                    let index = this.all_tasks.map(task => { return task.id; }).indexOf($event.id);
                    this.all_tasks[index].title = data.title;
                    this.all_tasks[index].due_date = data.due_date;
                    this.all_tasks[index].taskable = data.taskable ? data.taskable : null;
                });
            },

            deleteTask($event) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this task!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete task',
                    cancelButtonText: 'Keep task',
                    animation: false,
                }).then((result) => {
                    if (result.value) {
                        axios.delete('/api/tasks/' + $event, $event).then(() => {
                            let index = this.all_tasks.map(task => { return task.id; }).indexOf($event);
                            this.all_tasks.splice(index, 1);
                        });
                    }
                });
            },
        }, 

        computed: mapState(['user'])

    }
</script>

<style>

</style>